exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-text{margin:0;padding:6px 12px;background:#eef2f7;border-radius:4px!important;font-size:16px;color:#3a424e;margin-bottom:15px}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none}input[type=number]{-moz-appearance:textfield}.input-with-date,.vdp-datepicker input{width:100%}.btn-to-view ion-icon{margin-bottom:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-977c7bdc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/invoiceHistory/invoiceHistory.vue
// module id = 891
// module chunks = 0